import { render, staticRenderFns } from "./WarehousesUnload.vue?vue&type=template&id=0dd8a024&"
import script from "./WarehousesUnload.vue?vue&type=script&lang=js&"
export * from "./WarehousesUnload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports